import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { he } from 'date-fns/locale';
import { spacing, radius, height, colors, FontFamily, typographyScale, TypographyVariant } from 'common/theme';
import { FormFieldWrapper } from 'components/common/FormFieldWrapper';

const getInputBaseStyles = (theme, disabled, error, isFocused) => ({
  width: '100%',
  height: height.input,
  fontFamily: FontFamily.regular,
  fontSize: typographyScale[TypographyVariant.BodyLarge].fontSize,
  padding: `${spacing.md}px`,
  borderRadius: `${radius.md}px`,
  border: `1px solid ${
    error
      ? theme.palette.error.main
      : isFocused
      ? colors.palette.blue550
      : colors.palette.blueAlpha200
  }`,
  backgroundColor: colors.palette.white,
  transition: 'border-color 0.2s ease',
  '&:hover': {
    borderColor: !disabled && colors.palette.blue550,
  },
  '&.Mui-disabled': {
    backgroundColor: 'transparent',
  },
});

export const DatePickerFieldHot = ({
  testID,
  label,
  value,
  onChange,
  format = 'dd/MM/yyyy',
  placeholder = 'DD/MM/YYYY',
  locale = he,
  disabled = false,
  error = false,
  helperText,
  sx,
}) => {
  const theme = useTheme();
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <FormFieldWrapper label={label} testID={testID} disabled={disabled} error={error} helperText={helperText} sx={sx}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
        <DatePicker
          value={value}
          onChange={onChange}
          format={format}
          disabled={disabled}
          onOpen={handleFocus}
          onClose={handleBlur}
          slotProps={{
            textField: {
              placeholder,
              fullWidth: true,
              variant: 'standard',
              disabled,
              inputProps: {
                ...(testID ? {
                  testid: `${testID}-input`,
                } : {}),
                onFocus: handleFocus,
                onBlur: handleBlur,
              },
              InputProps: {
                disableUnderline: true,
                sx: {
                  ...getInputBaseStyles(theme, disabled, error, isFocused),
                  ...(disabled && {
                    backgroundColor: 'transparent',
                  }),
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </FormFieldWrapper>
  );
};

export default DatePickerFieldHot;

